<template>
  <div id="app" class="mt-16 ml-6" align="center">
    <router-link to="/">
        <v-img 
        src="../assets/InTheSuburbs-small.png"
        href="/"
        max-width="350"
        alt="InTheSuburbs.com.au"
      ></v-img>
      </router-link>

    <br>
    <br>
    <br>
    <br>
    <br>
    <br>
    <div v-if="showform"  class="d-flex justify-center mb-8">
      <v-card
        elevation="2"
        class="mx-auto pa-md-6"
        min-width="350"
        max-width="350"
      >
      <form
        @submit.prevent="getFormValues"
        method="POST"
      >
        <v-text-field
              v-model="name"
              :rules="nameRules"
              :counter="30"
              label="Your name"
              id="name"
              required
        ></v-text-field>

        <v-text-field
              v-model="email"
              :rules="emailRules"
              label="E-mail"
              id="email"
              required
        ></v-text-field>

         <v-textarea
          name="message"
          :counter="250"
          label="Message"
          id="message"
          required
        ></v-textarea>

        <div>
          <v-btn
            elevation="2"
            type="submit"
          >Send a message</v-btn>
        </div>
      </form>
    </v-card>
    <br>
    <br>
    <br>
  </div>
    <div v-if="submitted">
      <h2>Thank you!</h2>
      <div>We'll be in touch soon.</div>
    </div>
  </div>

</template>

<script>
import UseEmail from "../functions/UseEmail";

export default {
  name: "App",
  data: () => ({
    submitted: false,
    showform: true,
    name: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 30) || 'Name must be less than 30 characters',
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
  }),
  methods: {
    getFormValues (submitEvent) {
      const { loading, sumbmitted, error, sendEmail } = UseEmail("https://public.herotofu.com/v1/0a167d70-9f8b-11ed-82c7-3d7607318e65");
      sendEmail({
        date: new Date().toISOString(),
        user_name: submitEvent.target.elements.name.value,
        user_email: submitEvent.target.elements.email.value,
        user_message: submitEvent.target.elements.message.value,
      });
      setTimeout(() => {
        this.submitted = true;
        this.showform = false;
      }, 100);
    }
  },
  mounted() {
    this.pageTitle = "InTheSuburbs.com.au - Contact us",
    this.pageMeta = [
                    {
                        name: 'description',
                        content: 'Contact us, we would love to hear from you.'
                    },
                    {
                        property: 'og:description',
                        content: 'Contact us, we would love to hear from you.'
                    },
                    {
                        property: 'og:type',
                        content: 'website'
                    },
                    {
                        property: 'og:title',
                        content: 'Contact us, we would love to hear from you.'
                    }
  ]
  },
};
</script>